import React, { useState, useEffect } from 'react'
import Loading from '../general/Loading';
import '../css/Admin/ChannelList.css';
import { toast } from 'react-toastify';
import Csubscriber from './Csubscriber';

const ChannelList = ({userData}) => {
const [remark, setRemark] = useState('');
const [showDecline, setShowDecline] = useState(false);    const [channel, setChannel] = useState([]);
    const [loading, setLoading] = useState(false);
          const [searchQuery, setSearchQuery] = useState('');
const [statusFilter, setStatusFilter] = useState('Active');
const [review, setReview] = useState(false);
const [subscriber, setSubscriber] = useState(false);
const [selectedChannel, setSelectedChannel] = useState('');

  useEffect(() => {
    fetchChannel();
  }, []);
  

  const fetchChannel = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/get-all-channels');
      if (response.ok) {
        const data = await response.json();
        setChannel(data);
      } else {
        console.error('Failed to fetch topics');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterChannel = channel.filter(myItem =>
  (myItem.c_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
   myItem.puser_id?.toLowerCase().includes(searchQuery.toLowerCase())) &&
   myItem.status === statusFilter
);


                      const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }; 


  const handleAcceptRequest = async(id, user_id, email) => {
  try {
     const response = await fetch(`https://api.tradeintell.com/accept-channel-req`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({c_id: id, user_id, email})
        });
   const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || 'Something went wrong');
        }

                toast.success('Channel Request Accepted. This channel is Active now.');
       setReview(false);
       setSelectedChannel('');
                fetchChannel();

       } catch (error) {
         toast.error(error.message || 'Something went wrong. Try again.');
       } finally {
         setLoading(false);
       }
  }


    const handleChannelStatus = async(id) => {
  try {
     const response = await fetch(`https://api.tradeintell.com/update-channel-status`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({user_id: selectedChannel.user_id, c_id: id, status: selectedChannel.status == 'Active' ? 'Inactive' : 'Active', })
        });
   const data = await response.json();
  
        if (!response.ok) {
          throw new Error(data.message || 'Something went wrong');
        }

                toast.success(`Status updated. This channel is ${selectedChannel.status == 'Active' ? 'Inactive' : 'Active'} now.`);
       setReview(false);
       setSelectedChannel('');
                fetchChannel();

       } catch (error) {
         toast.error(error.message || 'Something went wrong. Try again.');
       } finally {
         setLoading(false);
       }
  }


  const handleDeclineRequest = async (id) => {

if(!remark.trim()){
toast.error("Please enter decline remark");
return;
}

setLoading(true);

try {

const response = await fetch(`https://api.tradeintell.com/decline-channel-req/${id}/${selectedChannel.email}/${remark}`, {
method: 'DELETE',
headers: {
'Content-Type': 'application/json'
},

});

const data = await response.json();

if (!response.ok) {
throw new Error(data.message || 'Something went wrong');
}

toast.success("Channel Request Rejected.");

setReview(false);
setShowDecline(false);
setRemark('');
setSelectedChannel('');

fetchChannel();

} catch (error) {
toast.error(error.message || 'Something went wrong');
} finally {
setLoading(false);
}

};

    return (
    <>
              <section className='my-4'>
        <div className='px-4'>
          <p className='page-heading'>{!subscriber ? 'Channel' : 'Subscribers'} List</p>
          <p className='para-text text-muted'>
            {!subscriber ? 
            'Manage all your active channels here & track new Channel Creation Requests in one place.'
          : 'View Channel Subscribers & their Subscription history. Track channel Admin Commission & Withdrawal requests.'}</p>

<hr />
{!subscriber &&

<>
<p className='fw-semibold text-light d-flex gap-2'>

<span
  className={`px-3 py-1 rounded-pill cursor-pointer para-text ${
    statusFilter === 'Active' ? 'bg-success' : 'bg-secondary'
  }`}
  onClick={() => setStatusFilter('Active')}
>
  Active Channels
</span>

<span
  className={`px-3 py-1 rounded-pill cursor-pointer para-text ${
    statusFilter === 'Inactive' ? 'bg-danger' : 'bg-secondary'
  }`}
  onClick={() => setStatusFilter('Inactive')}
>
  Inactive Channels
</span>

<span
  className={`px-3 py-1 rounded-pill cursor-pointer para-text ${
    statusFilter === 'Pending' ? 'bg-primary' : 'bg-secondary'
  }`}
  onClick={() => setStatusFilter('Pending')}
>
  Pending Requests
</span>

</p>

<div className='table-responsive mt-3'>
    <table className='table w-100 channel-table'>

        <thead className='channel-head'>
            <tr>
                <th>S No</th>
                <th>Created On</th>
                <th>Channel Name</th>
                <th>Admin</th>
                <th>User Name/ Id</th>
                <th>Status</th>
                <th>Activity</th>
            </tr>
        </thead>

<tbody className='para-text'>
      {filterChannel.length > 0 ? (
    filterChannel.map((c, index) => (
      <tr key={c.id}>
        <td>{index + 1}</td>
        <td>{formatDate(c.created_on)}</td>
        <td className='fw-semibold'>{c.c_name}</td>
        <td>{c.a_name}</td>
        <td>{c.name} / {c.puser_id}</td>
        <td><span className={`rounded px-2 py-1 para-text text-light fw-semibold ${c.status == 'Pending' ? 'bg-primary' : c.status == 'Active' ? 'bg-success' : 'bg-danger'}`}>{c.status}</span></td>
        <td>
            <button className='btn btn-outline-warning fw-semibold px-2 py-0' onClick={() => {
                setSelectedChannel(c); setReview(true);
            }}>Review</button>
            {c.status != 'Pending' &&
            <button className='btn btn-outline-success fw-semibold px-2 py-0 ms-2' onClick={() => {
                setSelectedChannel(c); setSubscriber(true);
            }}>Subscribers</button>
            }
</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">
        No Channel found.
      </td>
    </tr>
  )}
</tbody>
</table>
</div>
</>}

{subscriber &&
<Csubscriber channelData={selectedChannel} setSubscriber={setSubscriber} userData={userData} />}

</div>
</section>

{review && (
    <>
     <section className='detail-dialog p-2' onClick={() => setReview(false)}>
                    <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>
                        <button className='float-end btn btn-outline-warning' onClick={() => setReview(false)}>Close</button>
                        <p className='sidebar-menu-title text-dark fs-6 my-0'>Review</p>
          <p className='para-text text-muted'>Find the Channel details below.</p>

<div className='table-responsive'>
<table className='table w-100 border channel-table fw-semibold para-text'>
 <tr className='border'>
<td>Profile</td>
<td><img src={`https://api.tradeintell.com/uploads/${selectedChannel.profile_pic}`} 
onClick={() => window.open(`https://api.tradeintell.com/uploads/${selectedChannel.profile_pic}`, '_blank')} className='review-img' /></td>
    </tr>


    <tr className='border'>
<td>Name</td>
<td>{selectedChannel.c_name}</td>
    </tr>

        <tr className='border'>
<td>Admin</td>
<td>{selectedChannel.a_name}</td>
    </tr>

        <tr className='border'>
<td>User Name/Id</td>
<td>{selectedChannel.name} / {selectedChannel.puser_id}</td>
    </tr>

        <tr className='border'>
<td>Email</td>
<td>{selectedChannel.email}</td>
    </tr>

          <tr className='border'>
<td>UPI Id</td>
<td>{selectedChannel.upi_id ?? '-'}</td>
    </tr>

            <tr className='border'>
<td>Created On</td>
<td>{formatDate(selectedChannel.created_on)}</td>
    </tr>


        <tr className='border'>
<td>Status</td>
<td>{selectedChannel.status}</td>
    </tr>

        <tr className='border'>
<td>About</td>
<td>{selectedChannel.description ?? '-'}</td>
    </tr>

        <tr className='border'>
<td>Registration Document (optional)</td>
<td className='text-primary cursor-pointer' onClick={() => window.open(`https://api.tradeintell.com/uploads/${selectedChannel.files}`, '_blank')}>{selectedChannel.files ?? '-'}</td>
    </tr>


</table>
</div>

{selectedChannel.status != 'Pending' &&
            <button className='btn fw-semibold btn-outline-danger' onClick={() => handleChannelStatus(selectedChannel.id)}>Mark {selectedChannel.status == 'Active' ? 'Inactive' : "Active"}</button>
}

{!showDecline && selectedChannel.status == 'Pending' &&
<>
            <button className='btn fw-semibold btn-outline-success me-2' onClick={() => handleAcceptRequest(selectedChannel.id, selectedChannel.user_id, selectedChannel.email)}>Accept</button>
            <button className='btn fw-semibold btn-outline-danger' onClick={() => setShowDecline(true)}>Decline</button>
</>}

{showDecline && (
<div className='mt-1'>
<textarea
className='contact-control mb-3'
placeholder='Mention reason for rejecting channel...'
value={remark}
onChange={(e) => setRemark(e.target.value)}
/>

<button
className='btn btn-danger fw-semibold btn-sm'
onClick={() => handleDeclineRequest(selectedChannel.id)}
>
Reject Now
</button>

<button
className='btn btn-outline-secondary fw-semibold btn-sm ms-2'
onClick={() => {
setShowDecline(false);
setRemark('');
}}
>
Cancel
</button>

</div>
)}

</div>
</section>

    </>
)}


    
          {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default ChannelList